import Vue from 'vue'
import "babel-polyfill"
import Vuex from 'vuex'
import mutations from './mutations.js'
import actions from './actions.js'
import getters from './getters.js'
import cat from './modules/cat.js'
Vue.use(Vuex);
export default new Vuex.Store({
	state: {
		isLogin: false, // 是否登录
		token: '',
		tabActive: '', // 顶部导航
		loginOrReginter: true, // 登录还是注册 true login 、false register
		formVisible: false, //登录弹框是否开启
		toRouter: {} // 要前往的下一个页面
	},
	getters,
	mutations,
	actions,
	modules: {
		cat,
	}
})


// WEBPACK FOOTER //
// ./src/store/index.js